import { Injectable } from '@angular/core';
import { BaseclientService } from '../baseclient.service';
import { Observable, from, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

import { ToolsService } from '../../tools/tools.service';

@Injectable({
  providedIn: 'root'
})
export class MyPosService {



  private stripeKey: BehaviorSubject<any> = new BehaviorSubject(null);

  private KeyClientStripe: BehaviorSubject<any> = new BehaviorSubject(null);







  constructor(
    private baseClient: BaseclientService,
    private tools: ToolsService
  ) { }




  /**
      * @description get ClientKeyMypos
      */
  getClientKeyMyposBypof(id_user: any = null, metadata_provenance: any): Observable<any> {
    const params = {
      pos_id: this.tools.getStor("point_of_sale") && this.tools.getStor("point_of_sale").id ? this.tools.getStor("point_of_sale").id : null,
      id_user: id_user,
      metadata: metadata_provenance
    };


    return from(this.baseClient.postBase("getClientKeyMypos", params)).pipe(
      map(data => {
        return data;
      })
    )
  }



  /**
     * @description get ClientKeyMypos
     */
  getTokenSessionCreateMypos(IPCPaymentSessionCreate: any, metadata_provenance: any, id_user: any = null,$sanbox?:any): Observable<any> {

    const params = {
      pos_id: this.tools.getStor("point_of_sale") && this.tools.getStor("point_of_sale").id ? this.tools.getStor("point_of_sale").id : null,
      id_user: id_user,
      metadata: metadata_provenance,
      IPCPaymentSessionCreate: IPCPaymentSessionCreate,
      sanbox: $sanbox

    };

    return from(this.baseClient.postBase("getTokenSessionCreateMypos", params)).pipe(
      map(data => {
      
        return data;
      })
    )
  }


   /**
     * @description get getPaymentStatus
     */
   getPaymentStatus(IPCGetPaymentStatus: any, metadata_provenance: any, id_user: any = null,$sanbox?:any): Observable<any> {

    const params = {
      pos_id: this.tools.getStor("point_of_sale") && this.tools.getStor("point_of_sale").id ? this.tools.getStor("point_of_sale").id : null,
      id_user: id_user,
      metadata: metadata_provenance,
      IPCGetPaymentStatus: IPCGetPaymentStatus,
      sanbox: $sanbox

    };

    return from(this.baseClient.postBase("getPaymentStatus", params)).pipe(
      map(data => {
      
        return data;
      })
    )
  }

  /**
     * @description get ClientKeyMypos
     */
  getsignature(params: any): Observable<any> {



    return from(this.baseClient.postBase("cnf", params)).pipe(
      map(data => {
       
        return data;
      })
    )
  }




  /**
      * @description get ClientKeyMypos
      */
  gettoken(params: any): Observable<any> {



    return from(this.baseClient.postBase("createtoken", params)).pipe(
      map(data => {
             return data;
      })
    )
  }



















}




